// import '../assets/beautrium-css/home.scss'
import '../assets/beautrium-css/strapi.scss'
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import queryString from 'query-string';
import Page from '../components/Page';
// import { setFilter, setSort, getTrendyProducts, getPromotionProducts } from '../actions/material'; //getNewArrivals, getBestSellers, 
import { getPageLayoutStrapi } from '../actions/layout/index'
import { renderLayout } from '../assets/util.layout.strapi';

const frontload = async props => {
    const query = queryString.parse(props.location.search);
    return await props.getPageLayoutStrapi(props.page, (props.authenticated && _.get(props, "profile.role_id", 0) === 4 && query.preview)? query.layout_id: null)
    // return await props.getPageLayoutStrapi("home", 1);
}

class PageRender extends Component {

    componentDidMount() {
        const query = queryString.parse(this.props.location.search);
        if (query.preview && !this.props.authenticated && _.get(this.props, "profile.role_id", 0) !== 4) {
            // console.warn("UNCOMMENT TO SECURE THE PATH")
            this.props.history.push(this.props.location.pathname);
        }
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.location.search, this.props.location.search)) {
            const prevQuery = queryString.parse(prevProps.location.search);
            const query = queryString.parse(this.props.location.search);
            if (prevQuery.preview !== query.preview || prevQuery.layout_id !== query.layout_id) {
                this.props.getPageLayoutStrapi(this.props.page, (this.props.authenticated && _.get(this.props, "profile.role_id", 0) === 4 && query.preview)? query.layout_id: null)
            }
        }
    }

    render() {
        const { layoutComponents, title, keywords, description, og_image } = this.props; //new_mats, best_mats, promotion_section
        // const query = queryString.parse(search)
        return (
            <Page id="homepage" className="" title={title} description={description} keywords={keywords} image={og_image}>
                {/* <CouponSection history={this.props.history} /> */}
                {(layoutComponents && layoutComponents.length > 0)
                    ? renderLayout(layoutComponents)
                    : null}
            </Page>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        authenticated: state.auth.authenticated,
        profile: state.prof.profile,
        layoutComponents: state.layout.layouts ? state.layout.layouts[props.page] : [],
    }
}
export default connect(mapStateToProps, { getPageLayoutStrapi })(frontloadConnect(frontload, { onMount: true, onUpdate: false })(PageRender))
